import { render, staticRenderFns } from "./TradeConfigs.vue?vue&type=template&id=c9798b96&scoped=true"
import script from "./TradeConfigs.vue?vue&type=script&lang=js"
export * from "./TradeConfigs.vue?vue&type=script&lang=js"
import style0 from "./TradeConfigs.vue?vue&type=style&index=0&id=c9798b96&prod&scoped=true&lang=css"
import style1 from "./TradeConfigs.vue?vue&type=style&index=1&id=c9798b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9798b96",
  null
  
)

export default component.exports